/*
 * Copyright © Soft-logic LLC 2008-2022.
 * All rights to this software are owned by Soft-logic. Illegal copying and distribution is prohibited.
 * More information on the site http://paylogic-software.com/
 */

import Helper from '@/utils/helper'
import MenuItem from '@/app/service/api/model/menu-item'

class MenuItemList {
    constructor(items) {
        if (!Helper.isDefined(items)) {
            throw new Error('events is undefined')
        }
        this.items = []
        items.forEach((item) => {
            this.items.push(new MenuItem(item))
        })
    }

    isEmpty() {
        return this.items.length === 0
    }

    getItems() {
        return this.items
    }
}

export default MenuItemList
